(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-reviews"] && !Shopify.designMode) return;
  try {
    

  class YGReviews extends YGUtils {
      constructor() {
          super()
      }
      connectedCallback() {
        this.swiper = this.initSwiper(this);
      }
  }
  if (!window.customElements.get('yg-reviews')) {
      window.customElements.define('yg-reviews', YGReviews)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list"] && !Shopify.designMode) return;
  try {
    
  class YGVideoList extends YGUtils {
    constructor() {
      super();
      this.playVideo = this.playVideoFn.bind(this);
      this.currentPlayVideo = null
    }

    get videoList() {
      return this.querySelectorAll('yg-video.yg-video-box');
    }

    get currentVideo() {
      return this.querySelector('.swiper-slide-active yg-video.yg-video-box');
    }

    connectedCallback() {
      this.swiper = this.initSwiper(this);
      this.videoList.forEach(video => {
        video.addEventListener('mouseenter', this.playVideo);
      });
      this.swiper.on('slideChangeTransitionEnd', this.playVideo)
    }

    playVideoFn(event) {
      // event is an Event object, so get the target (yg-video element)
      const video = event.currentTarget || event.target || this.currentVideo;
      
      if (this.currentPlayVideo == video) return;
      this.currentPlayVideo = video
      
      this.videoList.forEach(v => {
        v.pauseVideo();
        if (v) {
          v.closest('.swiper-slide').classList.remove('current-play')
        }
      });

      if (video && typeof video.playVideo === 'function') {
        video.playVideo();
        video.closest('.swiper-slide').classList.add('current-play')
      }
    }
  }
  if (!window.customElements.get('yg-video-list')) {
    window.customElements.define('yg-video-list', YGVideoList)
  }

  } catch(e) { console.error(e); }
})();
})();
